import type { ICommand } from '../interfaces/Command';

export class CompositeCommand implements ICommand {
  private readonly _commands: Array<ICommand>;

  public constructor(...commands: Array<ICommand>) {
    this._commands = commands;
  }

  private async _reduce(callback: (command: ICommand) => Promise<undefined | boolean>): Promise<undefined | boolean> {
    let ret: boolean | undefined = undefined;
    for (const command of this._commands) {
      const res = await callback(command);
      if (res !== undefined && ret !== false) {
        ret = res;
      }
    }
    return ret;
  }

  public async execute(): Promise<undefined | boolean> {
    return this._reduce((command) => command.execute());
  }

  public async undo(): Promise<undefined | boolean> {
    return this._reduce((command) => command.undo ? command.undo() : Promise.resolve(undefined));
  }
}
